import Colors from '@figma/panda/Colors'
import { Box, IconButton, Stack, styled, Typography } from '@mui/material'
import FeatherIcon from 'feather-icons-react'

export const TemplateList = ({ templates, isLoading, onNavigateToTemplate, onDeleteTemplate }) => {
  if (isLoading) {
    return (
      <Box
        width="100%"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: '32px',
        }}
      >
        <Typography>Loading templates...</Typography>
      </Box>
    )
  }

  if (templates.length === 0) {
    return (
      <Box
        width="100%"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: '32px',
        }}
      >
        <Typography>No templates found. Create your first template to get started.</Typography>
      </Box>
    )
  }

  return (
    <StyledTemplatesContainer>
      <Stack width="100%" spacing="16px">
        {templates.map((template) => (
          <StyledTemplateItem key={template.id}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  cursor: 'pointer',
                  flex: 1,
                }}
                onClick={() => onNavigateToTemplate(template.id)}
              >
                <Typography variant="body1" sx={{ color: Colors.baseBlack }}>
                  {template.name}
                </Typography>
              </Box>
              <Box sx={{ marginLeft: '32px' }}>
                <IconButton size="medium" onClick={() => onDeleteTemplate(template.id)} data-testid={`delete-template-${template.id}`}>
                  <FeatherIcon icon="trash-2" size={16} />
                </IconButton>
              </Box>
            </Box>
          </StyledTemplateItem>
        ))}
      </Stack>
    </StyledTemplatesContainer>
  )
}

const StyledTemplatesContainer = styled(Box)`
  width: 50%;
  border: 1px solid ${Colors.base300};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
`

const StyledTemplateItem = styled(Box)`
  padding: 2px 32px;
  background-color: ${Colors.baseWhite};
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: ${Colors.base100};
  }
`
